import * as React from 'react';
import { format } from 'date-fns';

interface IProps {
    eventCruise: any;
    baseUrl: string;
}

export function EventGoogleScript({ eventCruise, baseUrl }: IProps) {
    const formatedStartDate = format(
        new Date(parseInt(eventCruise.earliestDeparture, 10) * 1000),
        'yyyy-MM-dd',
    );

    const formatedEndDate = format(
        new Date(parseInt(eventCruise.latestArrival, 10) * 1000),
        'yyyy-MM-dd',
    );

    const formatedUrl = baseUrl + eventCruise.cruisePageUrl;

    const script = `
        {
            "@context": "http://schema.org",
            "@type": "Event",
            "name": "${eventCruise.title}",
            "startDate": "${formatedStartDate}",
            "endDate": "${formatedEndDate}",
            "url": "${formatedUrl}",
            "location": {
              "@type": "Place",
              "name": "${eventCruise.region}"
            }}
    `;
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: script }} />;
}
